import { render, staticRenderFns } from "./EntryHeader.vue?vue&type=template&id=2e2bca53&"
import script from "./EntryHeader.vue?vue&type=script&lang=js&"
export * from "./EntryHeader.vue?vue&type=script&lang=js&"
import style0 from "./EntryHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports